import React, {useState, useEffect, memo} from 'react'
import PropTypes from 'prop-types'
import {Route, Redirect} from 'react-router-dom'
import {Link} from 'react-router-dom';
import {ServerConfig} from 'config'
import axios from 'axios'
import {useDispatch, useSelector} from 'react-redux'
import {logout} from '../../redux/actions/auth.js'

import NonPaginatedList from '../../components/EntryListAndEdit/NonPaginatedList'

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// @material-ui/core components
import {makeStyles} from '@material-ui/core/styles'
import {Typography, Grid, Hidden, Container, Modal, Button, Box} from '@material-ui/core'
import {ListGroup, ListGroupItem, Table} from 'reactstrap';

import Form from 'react-bootstrap/Form'

import EditComponent from 'components/EntryListAndEdit/EditComponent.js'
import Page from 'components/Page/Page'
import {getAllowedRoutes} from 'utils';
import _, {get} from 'lodash'

import SortableTbl from "react-sort-search-table";

const evt = new Event('customertable_is_dirty');
const evt_ledger = new Event('ledger_updated');

const useStyles = makeStyles((theme) => ({
  container: {
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    marginBottom: theme.spacing(8),
    [theme.breakpoints.down('xs')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(12)
    }
  },
  listItem: {
    fontSize: '15px',
    listStyle: 'none',
    margin: 0,
    padding: 0
  },
  listGroup: {
    margin: 0,
    padding: 0,
    marginBottom: 20,
  },
  label: {
    display: 'block',
    width: 200
  },
}))

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};


const Ledger = () => {
  let non_editable_fields = [];
  let materials = ["aluminum", "glass", "bi-metal", "plastic", "wds-bbp"];
  materials.map(function (material, bla) {
    non_editable_fields.push(["count_" + material, "Count " + material, "count"]);
  })

  let submaterials = ["aluminum", "glass", "bi-metal",
    "pete", "hdpe", "ldpe", "pp", "ps", "pvc",
    "paperboard-carton", "bag-in-box", "multilayer-pouch",
  ]
  submaterials.map(function (submaterial, bla) {
    non_editable_fields.push(["weight_" + submaterial + "_lbs", "Weight " + submaterial, "weight"]);
  })

  let myfields = [
    ["timestamp", "Date", "timestamp"],
    ["task_id", "Receipt #", ""],
    ["tenant_employee_name", "Employee Name", ""],
    ["customer_name", "Customer Name", ""],
    ["for_customer_paypal_email", "Customer Paypal Email", ""],
    ["for_customer_email", "Customer Email", ""],
    ["for_customer_phone_number", "Customer Phone", ""],
    ["total_transaction_value_microdollars", "Value", "currency"],
    ["cashed_out", "Cashed out", ""],
    ["additional_info_type", "Add.Info Type", "dont_show_if_empty"],
    ["additional_info_number", "Add.Info #", "dont_show_if_empty"],
    ["additional_info_state", "Add.Info State", "dont_show_if_empty"],
    ["belt_id", "Machine ID", ""],
    ["trackingcode_id", "EcoSack ID", ""],
    ["additional_info_signature", "Add.Info Sign.", "b64image"],
    ["task_changes", "Changes", "changelist"],
  ];
  myfields.map(function (entry, bla) {
    non_editable_fields.push(entry);
  })

  let date_before_1_week = new Date();
  date_before_1_week.setDate(new Date().getDate() - 7);
  //date_before_1_week.setUTCHours(0,0,0,0);
  date_before_1_week.setHours(0,0,0,0);

  let date_today = new Date();
  date_today.setHours(23,59,59,0);

  return (
    <>
      <NonPaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/ledger/`}
        detail_get_url={`${ServerConfig.SERVER_URL}/ledger/details/`}
        detail_put_url={undefined}

        column_names={["timestamp", "for_customer_name", "total_transaction_value_microdollars"]}
        header_names={["Date", "Customer Name", "Value"]}

        optional_column_names={["transactiontype", "note", "tenant_employee_name", "trackingcode_id", "for_tenant_name",
          "total_transaction_value_microdollars", "new_customer_balance"]}

        optional_header_names={["Transactiontype", "Note", "Employee Name","EcoSack ID", "Tenant",
          "Value", "Balance"]}

        filter_inputs={[
          {
            'name': 'device_ids',
            'type': 'device_ids',
            'label': 'Devices:',
            'initial_value': undefined,
          },
          {
            'name': 'start_ts_utc',
            'type': 'utc_date_start',
            'label': 'Start-Date (incl.):',
            'initial_value': date_before_1_week
          },
          {'name': 'end_ts_utc', 'type': 'utc_date_end', 'label': 'End-Date (incl.):', 'initial_value': date_today}
        ]}

        editable_fields={[]}
        non_editable_fields={non_editable_fields}
        show_machine_stats={false}
        show_get_receipt_pdfs={true}
        show_transactiontype_summary={true}
      />
    </>
  )
}

export default Ledger
